module.exports = __webpack_public_path__ + "img/chapter_divider.9c82a31.svg";